const alertEmail = (result, dispatch, { navigate }) => {
    alert('Votre message a bien été envoyé !\n\n En cliquant sur OK vous serez redirigé vers la liste des rips');
    navigate('/');
};

export default alertEmail;
